import {
	Ad,
	Ae,
	Af,
	Ag,
	Ai,
	Al,
	Am,
	An,
	Ao,
	Aq,
	Ar,
	As,
	At,
	Au,
	Aw,
	Ax,
	Az,
	Ba,
	Bb,
	Bd,
	Be,
	Bf,
	Bg,
	Bh,
	Bi,
	Bj,
	Bl,
	Bm,
	Bn,
	Bo,
	Bq,
	Br,
	Bs,
	Bt,
	Bv,
	Bw,
	By,
	Bz,
	Ca,
	Cc,
	Cd,
	Cf,
	Cg,
	Ch,
	Ci,
	Ck,
	Cl,
	Cm,
	Cn,
	Co,
	Cr,
	Cu,
	Cv,
	Cw,
	Cx,
	Cy,
	Cz,
	De,
	Dj,
	Dk,
	Dm,
	Do,
	Dz,
	Ec,
	Ee,
	Eg,
	Eh,
	Er,
	Es,
	Et,
	Eu,
	Fi,
	Fj,
	Fk,
	Fm,
	Fo,
	Fr,
	Ga,
	GbEng,
	GbNir,
	GbSct,
	GbWls,
	Gb,
	Gd,
	Ge,
	Gf,
	Gg,
	Gh,
	Gi,
	Gl,
	Gm,
	Gn,
	Gp,
	Gq,
	Gr,
	Gs,
	Gt,
	Gu,
	Gw,
	Gy,
	Hk,
	Hm,
	Hn,
	Hr,
	Ht,
	Hu,
	Id,
	Ie,
	Il,
	Im,
	In,
	Io,
	Iq,
	Ir,
	Is,
	It,
	Je,
	Jm,
	Jo,
	Jp,
	Ke,
	Kg,
	Kh,
	Ki,
	Km,
	Kn,
	Kp,
	Kr,
	Kw,
	Ky,
	Kz,
	La,
	Lb,
	Lc,
	Li,
	Lk,
	Lr,
	Ls,
	Lt,
	Lu,
	Lv,
	Ly,
	Ma,
	Mc,
	Md,
	Me,
	Mf,
	Mg,
	Mh,
	Mk,
	Ml,
	Mm,
	Mn,
	Mo,
	Mp,
	Mq,
	Mr,
	Ms,
	Mt,
	Mu,
	Mv,
	Mw,
	Mx,
	My,
	Mz,
	Na,
	Nc,
	Ne,
	Nf,
	Ng,
	Ni,
	Nl,
	No,
	Np,
	Nr,
	Nu,
	Nz,
	Om,
	Pa,
	Pe,
	Pf,
	Pg,
	Ph,
	Pk,
	Pl,
	Pm,
	Pn,
	Pr,
	Ps,
	Pt,
	Pw,
	Py,
	Qa,
	Re,
	Ro,
	Rs,
	Ru,
	Rw,
	Sa,
	Sb,
	Sc,
	Sd,
	Se,
	Sg,
	Sh,
	Si,
	Sj,
	Sk,
	Sl,
	Sm,
	Sn,
	So,
	Sr,
	Ss,
	St,
	Sv,
	Sx,
	Sy,
	Sz,
	Tc,
	Td,
	Tf,
	Tg,
	Th,
	Tj,
	Tk,
	Tl,
	Tm,
	Tn,
	To,
	Tr,
	Tt,
	Tv,
	Tw,
	Tz,
	Ua,
	Ug,
	Um,
	Us,
	Uy,
	Uz,
	Va,
	Vc,
	Ve,
	Vg,
	Vi,
	Vn,
	Vu,
	Wf,
	Ws,
	Xk,
	Ye,
	Yt,
	Za,
	Zm,
	Zw
} from './js'

const FlagMap = {
	ad: Ad,
	ae: Ae,
	af: Af,
	ag: Ag,
	ai: Ai,
	al: Al,
	am: Am,
	an: An,
	ao: Ao,
	aq: Aq,
	ar: Ar,
	as: As,
	at: At,
	au: Au,
	aw: Aw,
	ax: Ax,
	az: Az,
	ba: Ba,
	bb: Bb,
	bd: Bd,
	be: Be,
	bf: Bf,
	bg: Bg,
	bh: Bh,
	bi: Bi,
	bj: Bj,
	bl: Bl,
	bm: Bm,
	bn: Bn,
	bo: Bo,
	bq: Bq,
	br: Br,
	bs: Bs,
	bt: Bt,
	bv: Bv,
	bw: Bw,
	by: By,
	bz: Bz,
	ca: Ca,
	cc: Cc,
	cd: Cd,
	cf: Cf,
	cg: Cg,
	ch: Ch,
	ci: Ci,
	ck: Ck,
	cl: Cl,
	cm: Cm,
	cn: Cn,
	co: Co,
	cr: Cr,
	cu: Cu,
	cv: Cv,
	cw: Cw,
	cx: Cx,
	cy: Cy,
	cz: Cz,
	de: De,
	dj: Dj,
	dk: Dk,
	dm: Dm,
	do: Do,
	dz: Dz,
	ec: Ec,
	ee: Ee,
	eg: Eg,
	eh: Eh,
	er: Er,
	es: Es,
	et: Et,
	eu: Eu,
	fi: Fi,
	fj: Fj,
	fk: Fk,
	fm: Fm,
	fo: Fo,
	fr: Fr,
	ga: Ga,
	'gb-eng': GbEng,
	'gb-nir': GbNir,
	'gb-sct': GbSct,
	'gb-wls': GbWls,
	gb: Gb,
	gd: Gd,
	ge: Ge,
	gf: Gf,
	gg: Gg,
	gh: Gh,
	gi: Gi,
	gl: Gl,
	gm: Gm,
	gn: Gn,
	gp: Gp,
	gq: Gq,
	gr: Gr,
	gs: Gs,
	gt: Gt,
	gu: Gu,
	gw: Gw,
	gy: Gy,
	hk: Hk,
	hm: Hm,
	hn: Hn,
	hr: Hr,
	ht: Ht,
	hu: Hu,
	id: Id,
	ie: Ie,
	il: Il,
	im: Im,
	in: In,
	io: Io,
	iq: Iq,
	ir: Ir,
	is: Is,
	it: It,
	je: Je,
	jm: Jm,
	jo: Jo,
	jp: Jp,
	ke: Ke,
	kg: Kg,
	kh: Kh,
	ki: Ki,
	km: Km,
	kn: Kn,
	kp: Kp,
	kr: Kr,
	kw: Kw,
	ky: Ky,
	kz: Kz,
	la: La,
	lb: Lb,
	lc: Lc,
	li: Li,
	lk: Lk,
	lr: Lr,
	ls: Ls,
	lt: Lt,
	lu: Lu,
	lv: Lv,
	ly: Ly,
	ma: Ma,
	mc: Mc,
	md: Md,
	me: Me,
	mf: Mf,
	mg: Mg,
	mh: Mh,
	mk: Mk,
	ml: Ml,
	mm: Mm,
	mn: Mn,
	mo: Mo,
	mp: Mp,
	mq: Mq,
	mr: Mr,
	ms: Ms,
	mt: Mt,
	mu: Mu,
	mv: Mv,
	mw: Mw,
	mx: Mx,
	my: My,
	mz: Mz,
	na: Na,
	nc: Nc,
	ne: Ne,
	nf: Nf,
	ng: Ng,
	ni: Ni,
	nl: Nl,
	no: No,
	np: Np,
	nr: Nr,
	nu: Nu,
	nz: Nz,
	om: Om,
	pa: Pa,
	pe: Pe,
	pf: Pf,
	pg: Pg,
	ph: Ph,
	pk: Pk,
	pl: Pl,
	pm: Pm,
	pn: Pn,
	pr: Pr,
	ps: Ps,
	pt: Pt,
	pw: Pw,
	py: Py,
	qa: Qa,
	re: Re,
	ro: Ro,
	rs: Rs,
	ru: Ru,
	rw: Rw,
	sa: Sa,
	sb: Sb,
	sc: Sc,
	sd: Sd,
	se: Se,
	sg: Sg,
	sh: Sh,
	si: Si,
	sj: Sj,
	sk: Sk,
	sl: Sl,
	sm: Sm,
	sn: Sn,
	so: So,
	sr: Sr,
	ss: Ss,
	st: St,
	sv: Sv,
	sx: Sx,
	sy: Sy,
	sz: Sz,
	tc: Tc,
	td: Td,
	tf: Tf,
	tg: Tg,
	th: Th,
	tj: Tj,
	tk: Tk,
	tl: Tl,
	tm: Tm,
	tn: Tn,
	to: To,
	tr: Tr,
	tt: Tt,
	tv: Tv,
	tw: Tw,
	tz: Tz,
	ua: Ua,
	ug: Ug,
	um: Um,
	us: Us,
	uy: Uy,
	uz: Uz,
	va: Va,
	vc: Vc,
	ve: Ve,
	vg: Vg,
	vi: Vi,
	vn: Vn,
	vu: Vu,
	wf: Wf,
	ws: Ws,
	xk: Xk,
	ye: Ye,
	yt: Yt,
	za: Za,
	zm: Zm,
	zw: Zw
}

export default FlagMap
